import { render, staticRenderFns } from "./ConfArea.vue?vue&type=template&id=5131e75b&scoped=true&"
import script from "./ConfArea.vue?vue&type=script&lang=js&"
export * from "./ConfArea.vue?vue&type=script&lang=js&"
import style0 from "./ConfArea.vue?vue&type=style&index=0&id=5131e75b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5131e75b",
  null
  
)

export default component.exports